import script from "./Quote1PDF.vue?vue&type=script&setup=true&lang=js"
export * from "./Quote1PDF.vue?vue&type=script&setup=true&lang=js"

import "./Quote1PDF.vue?vue&type=style&index=0&id=d84b38c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d84b38c6"]])

export default __exports__